<template>
  <div class="gid-comment rounded-lg p-2 mb-2">
    <template v-if="!editMode">
      <div v-html="comment.message" class="mb-2"></div>
      <div class="d-flex text-capitalize align-items-baseline">
        <template v-if="isAdmin">
          <b-button
            v-if="!simple"
            size="sm"
            variant="outline-secondary"
            class="mr-1"
            @click="editComment"
          >
            <span class="material-icons">edit</span>
          </b-button>
          <b-button
            v-if="!simple"
            size="sm"
            variant="outline-secondary"
            class="mr-1"
            @click="$emit('deleteComment', comment)"
          >
            <span class="material-icons">delete</span>
          </b-button>
          <small class="mr-2">
            <em class="text-muted">
              <span class="material-icons">visibility</span>
              {{ comment.visibleForRoles.join(', ') }}
            </em>
          </small>
        </template>
        <div class="text-right ml-auto">
          <div v-if="comment.updatedAt != comment.createdAt">
            <small class="mx-2">
              {{ $t('comments.last-update') }}
              {{ comment.updatedAt | moment('lll') }}
            </small>
          </div>
          <div
            v-if="
              user && user.role != 'partner' && comment.actionType != 'generic'
            "
            class="gid-comment-badge badge badge-success"
          >
            <span class="mx-2">{{ $t('comments.action-taken-by') }}</span>
            <span>
              {{ $t(`comments.${comment.actionType}`) }}
              <span class="material-icons gid-action-type mx-2">
                {{ actionTypeString }}
              </span>
            </span>
          </div>
          <div>
            <small>
              <strong>{{ comment | getName }}</strong>
              ,
              {{ comment.createdAt | moment('lll') }}
            </small>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <rich-text-comments v-model="modifiedComment" />
      <div class="d-flex">
        <b-button
          size="sm"
          variant="outline-primary"
          class="mr-1"
          @click="editSave"
          :disabled="disableSaveComment"
        >
          <b-spinner v-if="saving" small></b-spinner>
          {{ $t('comments.save') }}
        </b-button>
        <b-button
          size="sm"
          variant="outline-secondary"
          class="mr-1"
          @click="editCancel"
        >
          {{ $t('comments.cancel') }}
        </b-button>
        <div class="text-right ml-auto">
          <small>
            <strong>{{ comment | getName }}</strong>
            ,
            {{ comment.createdAt | moment('lll') }}
          </small>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import RichTextComments from './inputs/RichTextComments.vue';
import { UserRoleEnum } from '@gid/models';
import { mapGetters } from 'vuex';
import { CommentActionTypeEnum } from '@gid/models/dist/entities/comment';

export default {
  components: {
    RichTextComments,
  },
  props: {
    comment: Object,
    simple: Boolean,
  },
  data() {
    return {
      editMode: false,
      modifiedComment: {
        message: null,
        visible_for_roles: [],
        action_type: null,
        took_action: false,
      },
      saving: false,
    };
  },
  computed: {
    ...mapGetters(['user']),
    actionTypeString() {
      let icon = '';
      switch (this.comment.actionType) {
        case 'forwarded':
          icon = 'drafts';
          break;
        case 'kva_sent':
          icon = 'description';
          break;
        default:
          icon = this.comment.actionType;
          break;
      }
      return icon;
    },
    isAdmin() {
      return this.user?.role == UserRoleEnum.ADMIN;
    },
    disableSaveComment() {
      return (
        this.saving ||
        !this.modifiedComment.message ||
        (this.modifiedComment.took_action &&
          this.modifiedComment.action_type == CommentActionTypeEnum.GENERIC)
      );
    },
  },
  watch: {
    comment: {
      deep: true,
      handler() {
        this.editMode = false;
        this.saving = false;
      },
    },
  },
  filters: {
    getName(comment) {
      let name =
        comment.creatorRole == UserRoleEnum.ADMIN ? 'GID' : comment.creatorRole;
      if (comment.user) {
        name += `: ${comment.user.name}`;
      }
      return name;
    },
  },
  methods: {
    editComment() {
      this.modifiedComment = {
        message: this.comment.message,
        visible_for_roles: this.comment.visibleForRoles,
        action_type: this.comment.actionType,
      };

      this.editMode = true;
    },
    editSave() {
      this.saving = true;
      this.$emit('editComment', {
        id: this.comment.id,
        message: this.modifiedComment.message,
        visibleForRoles: this.modifiedComment.visible_for_roles,
        actionType: this.modifiedComment.action_type,
      });
    },
    editCancel() {
      this.editMode = false;
      this.saving = false;
    },
  },
};
</script>

<style lang="scss">
.gid-comment {
  background: #fafafa;
  border: 1px solid rgba($color: #000, $alpha: 0.1);

  .material-icons {
    font-size: 1em;
    vertical-align: middle;
  }

  .gid-comment-badge {
    background: #2d83ff;
  }
  .gid-action-type {
    font-size: 1rem;
  }
}
</style>
